import { ButtonProps, Col, Divider, Modal, ModalProps, Popconfirm, PopconfirmProps, Row } from 'antd';
import { FC, ReactNode } from 'react';
import ButtonWrap from '../ButtonWrap';
import SvgClose from '../svg/SvgClose';
import './style.scss';
import { useIntl } from 'react-intl';

export type ModalWrapType = 'upsert' | 'delete';

export interface ModalWrapProps extends ModalProps {
  title: ReactNode;
  body: ReactNode;
  type: ModalWrapType;
  cancelText?: ReactNode;
  submitText?: ReactNode;
  isScrollBody?: boolean;
  buttonSubmitProps?: ButtonProps;
  buttonCancelProps?: ButtonProps;
  onSubmit: () => void;
  onCancel: () => void;
  hideSubmitText?: boolean;
  confirmProps?: PopconfirmProps;
}

const ModalWrap: FC<ModalWrapProps> = (props) => {
  const intl = useIntl();
  const {
    title,
    body,
    type,
    cancelText = intl.formatMessage({ id: 'common.cancel' }),
    submitText = intl.formatMessage({ id: 'common.submit' }),
    wrapClassName,
    onSubmit,
    onCancel,
    isScrollBody = false,
    buttonSubmitProps,
    buttonCancelProps,
    width,
    hideSubmitText,
    confirmProps,
    ...otherProps
  } = props;

  return (
    <>
      <Modal
        {...otherProps}
        closable={false}
        centered
        onCancel={onCancel}
        wrapClassName={`custom_modal ${wrapClassName || ''}`}
        footer={null}
        width={width ?? 680}
      >
        <Row>
          <Col span={24} className="custom_modal-header">
            <Row align="middle" justify="space-between">
              <Col>
                <span className="custom_modal-header-title">{title}</span>
              </Col>

              <Col className="custom_modal-header-close" onClick={onCancel}>
                <SvgClose />
              </Col>
            </Row>
          </Col>

          <Divider className="custom_modal-divider" />

          <Col span={24} className={`custom_modal-body ${isScrollBody ? 'custom_modal-body-scroll' : ''}`}>
            {body}
          </Col>

          <Divider className="custom_modal-divider" />

          <Col span={24} className="custom_modal-footer">
            <Row align="middle" justify="end" gutter={[8, 8]}>
              <Col>
                <ButtonWrap {...buttonCancelProps} width={162} variant="filled" color="black" onClick={onCancel}>
                  {cancelText}
                </ButtonWrap>
              </Col>
              {!hideSubmitText && (
                <Col>
                  {confirmProps ? (
                    <Popconfirm placement="topLeft" {...confirmProps} onConfirm={onSubmit}>
                      <ButtonWrap
                        {...buttonSubmitProps}
                        width={162}
                        variant={type === 'upsert' ? 'filled' : 'outlined'}
                        color={type === 'upsert' ? 'primary' : 'danger'}
                      >
                        {submitText}
                      </ButtonWrap>
                    </Popconfirm>
                  ) : (
                    <ButtonWrap
                      {...buttonSubmitProps}
                      width={162}
                      variant={type === 'upsert' ? 'filled' : 'outlined'}
                      color={type === 'upsert' ? 'primary' : 'danger'}
                      onClick={onSubmit}
                    >
                      {submitText}
                    </ButtonWrap>
                  )}
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default ModalWrap;
